import React from "react";
import ActionConfigNode, { type ExtraNodeData, type InterfaceToRecord } from "./action-config-node";
import type { NodeProps, Node } from "@xyflow/react";

type OrNode = Node<InterfaceToRecord<ExtraNodeData>>;

export default function Or(props: NodeProps<OrNode>): JSX.Element {
    return <ActionConfigNode nodeKind={props.type} {...props.data} />;
}
